import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
  auth: {
    clientId: "5265c738-6c73-4742-aa3c-db1976f19293",
    authority:"https://login.microsoftonline.com/68a2a45b-d866-4daf-b724-0208e7e53893",   
    redirectUri: "https://prod-be.tecoalesce.com/v1/ssologin/auth/azure/callback",
    // callbackURL:"https://15.206.231.25:9701/v1/ssologin/auth/azure/callback",
    // postLogoutRedirectUri: "http://localhost:3000", 
    navigateToLoginRequestUrl: true,   
    responseMode: "query" ,
    responseType: "code"
  },
 
  cache: {
    cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        // console.log(`[${LogLevel[level]}] ${message}`);

        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            //  console.error(message,level,message);
            return;
          case LogLevel.Info:
            //  console.info(message);
            return;
          case LogLevel.Verbose:
            // console.debug(message);
            return;
          case LogLevel.Warning:
            // console.warn(message);
            return;
          default:
            break;
        }
      },
      logLevel: LogLevel.Info,
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
// export const loginRequest = {
//    scopes: [],
// };
export const loginRequest = {
  scopes: ["openid", "profile", "email", "offline_access","User.Read"],
};
/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  graphMe: {
    endpoint: "https://graph.microsoft.com/v1.0/me",
    scopes: ["User.Read"],
  },
  graphMail: {
    endpoint: "https://graph.microsoft.com/v1.0/me/messages",
    scopes: ["Mail.Read"]
  },
  apiHello: {
    endpoint: "http://localhost:5000/hello",
    scopes: [`api://5265c738-6c73-4742-aa3c-db1976f19293/User.Read`], // e.g. api://xxxxxx/access_as_user
  },
};
// Add configuration for token renewal
export const tokenRequest = {
  scopes: [...loginRequest.scopes],
  forceRefresh: false
};


